/**
 * HelpMenu — Help Center / Tour / Shortcuts / About.
 *
 * Reuses the existing HelpCenter dialog and TourProvider's startTour;
 * does NOT duplicate the `?` button in the chip strip (that's quick
 * contextual help — this menu is for long-form items).
 */
import React from 'react';
import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Article,
  BugReport,
  HelpOutline,
  Info,
  Keyboard,
  PlayCircleOutline,
} from '@mui/icons-material';

const HelpMenu = ({
  anchorEl,
  open,
  onClose,
  onHelpCenter,
  onStartTour,
  onKeyboardShortcuts,
  onAbout,
}) => {
  const wrap = (fn) => () => { onClose(); fn?.(); };

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem onClick={wrap(onHelpCenter)} dense>
        <ListItemIcon><HelpOutline fontSize="small" /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
          Help Center
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={wrap(onStartTour)} dense>
        <ListItemIcon><PlayCircleOutline fontSize="small" /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
          Interactive Tour
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={wrap(onKeyboardShortcuts)} dense>
        <ListItemIcon><Keyboard fontSize="small" /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
          Keyboard Shortcuts…
        </ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem
        component="a"
        href="/changelog"
        onClick={onClose}
        dense
      >
        <ListItemIcon><Article fontSize="small" /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
          Release Notes
        </ListItemText>
      </MenuItem>
      <MenuItem
        component="a"
        href="mailto:support@evolunic.com?subject=EIS%20Issue%20Report"
        onClick={onClose}
        dense
      >
        <ListItemIcon><BugReport fontSize="small" /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
          Report Issue
        </ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={wrap(onAbout)} dense>
        <ListItemIcon><Info fontSize="small" /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
          About EIS
        </ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default HelpMenu;
